module.exports = __webpack_public_path__ + "static/media/document-guidelines@2x.6235d13a.png";